// extracted by mini-css-extract-plugin
module.exports = {"button":"CopyAddressButton_button__mf4xY"};